import React from "react";
import { COLORS, FONTS } from "./constants";
import { TrustCard, MiniQuery, paraStyle } from "./TrustCard";
import { glow } from "./shared";

// You can see the cost — every answer now shows what it cost to produce.
// Before: an answer with no cost anywhere. After: the same answer, with a cost
// badge in the footer.
export const Scene10Cost: React.FC = () => {
  const answer = "Batch analysis uses a worker-pool pattern with 8 workers and 50-item shards.";

  const before = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <MiniQuery text="How is batch analysis built?" />
      <p style={paraStyle}>{answer}</p>
      <div style={{ marginTop: "auto" }}>
        <Footer>
          <span style={{ color: COLORS.textSecondary }}>Answered · 2.1s</span>
          <span style={{ color: COLORS.textMuted, fontStyle: "italic" }}>cost: not shown</span>
        </Footer>
      </div>
    </div>
  );

  const after = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <MiniQuery text="How is batch analysis built?" />
      <p style={paraStyle}>{answer}</p>
      <div style={{ marginTop: "auto" }}>
        <Footer>
          <span style={{ color: COLORS.textSecondary }}>Answered · 2.1s</span>
          <span style={{
            fontFamily: FONTS.mono, fontWeight: 700, color: COLORS.neonYellow,
            padding: "8px 16px", borderRadius: 10,
            background: `${COLORS.neonYellow}14`, border: `1.5px solid ${COLORS.neonYellow}88`,
            textShadow: glow(COLORS.neonYellow),
          }}>
            $0.0021 · 3,240 tokens
          </span>
        </Footer>
      </div>
    </div>
  );

  return (
    <TrustCard
      accent={COLORS.neonYellow}
      index="4 / 4"
      title="You can see the cost"
      subtitle="Every answer shows exactly what it cost to produce."
      before={before}
      after={after}
    />
  );
};

const Footer: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    gap: 16, paddingTop: 18, fontSize: 21, fontFamily: FONTS.body,
    borderTop: `1px solid ${COLORS.textMuted}44`,
  }}>
    {children}
  </div>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
